<template>
  <div class="hover-table">
    <o-table
      :data="myQuestionnaires"
      v-if="myQuestionnaires && myQuestionnaires.length > 0"
      hoverable
      persistent
      @click="viewQuestionnaireStatus"
    >
      <o-table-column v-for="column in columns" v-bind="column">
        <template #default="props">
          <div class="d-flex align-center mt-1 mb-1">
            <p>{{ props.row.label }}</p>
          </div>
        </template>
      </o-table-column>
    </o-table>
  </div>
</template>

<script setup lang="ts">
import type { Questionnaire } from "@/models/questionnaire";
import { ref } from "vue";

defineProps<{
  myQuestionnaires: Array<Questionnaire>;
}>();

const emit = defineEmits<{
  (e: "view-questionnaire-status", myQuestionnaire: Questionnaire): void;
}>();

const columns = ref([
  {
    field: "questionnaireLabel",
    label: "Questionnaire name",
    sortable: true,
  },
]);

function viewQuestionnaireStatus(tableRow: any) {
  emit("view-questionnaire-status", tableRow);
}
</script>

<style scoped lang="scss">
.hover-table:hover {
  cursor: pointer;
}
</style>
